import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IconBadge } from '@core/services/room-details/room-details.service';
import { MbIconTextModule, MbIconModule } from '@am/moebius';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'am-disney-supplements',
    templateUrl: './disney-supplements.component.html',
    styleUrls: ['./disney-supplements.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        MbIconTextModule,
        MbIconModule,
    ],
})
export class DisneySupplementsComponent implements OnInit {
  @Input()
  public supplements: IconBadge<string>[] = [];

  constructor() {}

  ngOnInit(): void {}
}
